import logo from "../assets/images/logo-white.png";
import LazyImage from "../components/ui/LazyImage";
import bgLogin from "../assets/images/global-network.png";
import LoginForm from "../features/auth/components/LoginForm";

export default function LoginPage() {
  return (
    <>
      <div className="h-screen xl:flex items-center justify-between bg-green-gradient">
        <div className="h-full relative flex items-center justify-center xl:w-1/2">
          <LazyImage
            src={bgLogin}
            alt="login page"
            className="w-full h-full object-cover background-login"
          />
        </div>
        <div className="absolute xl:relative inset-0 z-10 xl:w-1/2 flex flex-col gap-[50px] items-center justify-center">
          <div className="logo-container flex flex-col items-center">
            <LazyImage src={logo} alt="logo almostanad" className="w-[90px] mb-4" />
            <h1 className="font-kahroba font-[600] text-[34px] text-white leading-[100%] tracking-[0%]">
              مستند
            </h1>
            <p className="font-kahroba font-[500] text-[18px] text-white">
              موسسه آل البیت علیهم السلام
            </p>
          </div>
          <div className="form-container xl:w-96">
            <LoginForm />
          </div>
        </div>
      </div>
    </>
  );
}
